import errorImage from '/server-error.svg';
import { Error } from '@/components';

const ServerError = () => {
  return <Error imageSrc={errorImage} errorTitle={'500'} />;
};

export default ServerError;
